import React from 'react'

const DocumentsSmBox = (props) => {
  return (
    <>
        <div className="bxmain">
        

            <div className="thebox">
                <div className="firstwrapper">
                <div className="img">

                <img src="./assets/images/dashboards/adminDashboard/icon/classworkicon.png" alt="" />
                </div>
                <div className="text">
                    <h5>Class Work</h5>
                    <h6>Monday, 27 March 2023</h6>
                </div>

                </div>
                <div className="downloadbtn">
                    <img src="./assets/images/dashboards/adminDashboard/icon/dwnicon.png" alt="" />
                </div>
            </div>
        </div>
    </>
  )
}

export default DocumentsSmBox